<p>custom-date-picker works!</p>
<div class="example-header">

    <button (click)="infoClicked()">
          ?
        </button>

    <span class="example-header-label">{{periodLabel}}</span>

    <button (click)="closeCalendar()">
          X
        </button>
</div>
<hr>
<div class="example-header-today">
    <span class="test" [matMenuTriggerFor]="beforeMenu" #triggerFor *ngIf="previousBoolean" style="margin-top:22px;"></span>
    <button (click)="previousClicked('year')" (mousedown)="onMouseDownPrevious($event,'year')" (mouseup)="onMouseUp()">
        <<
            
        </button>

    <button (click)="previousClicked('month')" (mousedown)="onMouseDownPrevious($event,'month')" (mouseup)="onMouseUp()">
        <
           
            <mat-menu #beforeMenu="matMenu">
                <span mat-menu-item *ngFor="let item of itemList; let i = index;" (click)="onClickItem(item,i)">{{item}}</span>      
            </mat-menu>
    </button>

    <span class="example-header-label-today" (click)="setTodayDate()">Today</span>

    <button (click)="nextClicked('month')" (mousedown)="onMouseDown($event,'month')" (mouseup)="onMouseUp()"> >
            
    </button>
    <button (click)="nextClicked('year')" (mousedown)="onMouseDown($event,'year')" (mouseup)="onMouseUp()">>>
            
            <mat-menu #menu="matMenu" class="right" xPosition="before">               
                <span mat-menu-item *ngFor="let item of itemList; let i = index;" (click)="onClickItem(item,i)">{{item}}</span>              
            </mat-menu>
    </button>
    <span class="test1" [matMenuTriggerFor]="menu" #triggerFor *ngIf="nextBoolean" style="margin-top:22px;"></span>


</div>

<hr>